import FormGuideEventHeader from './FormGuideEventHeader.vue';
import EventHeaderMoreInfoModal from './EventHeaderMoreInfoModal.vue';
import state from './state/FormGuideEventHeader';

// We are intentionally exposing components that *may* be required by the bundle-consumer
// Source-code-consumers like odds.com.au can directly import modules, so are not affected
export default {
  FormGuideEventHeader,
  EventHeaderMoreInfoModal,
  state,
};
